<template>
  <div class="layout">
    <header>
      <nav class="navbar navbar-expand-lg navbar-dark py-0" id="navbar">
        <div class="container">
          <router-link class="nav-link" to="/">
            <img src="../assets/img/logo.png" height="50" class="d-inline-block align-top" alt="">
          </router-link>
          <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSC" aria-controls="navbarSC" aria-expanded="false" aria-label="Toggle navigation">
            <span class="navbar-toggler-icon"></span>
          </button>

          <div class="collapse navbar-collapse" id="navbarSC">
            <ul class="navbar-nav mr-auto">
              <li class="nav-item">
                <router-link class="nav-link" :to="{name: 'home'}">Accueil</router-link>
              </li>
              <li class="nav-item">
                <router-link class="nav-link" :to="{name: 'about'}">Services</router-link>
              </li>
              <li class="nav-item">
                <router-link class="nav-link" :to="{name: 'home'}">Documentation</router-link>
              </li>
              <li class="nav-item">
                <router-link class="nav-link" :to="{name: 'about'}">A propos</router-link>
              </li>
            </ul>
            <div class="d-flex my-1" v-if="!$store.getters.isLogged">
              <button type="button" class="btn btn-warning mr-3" data-toggle="modal" @click="onModal('signin')">Se connecter</button>
              <button class="btn btn-outline-light" type="button" data-toggle="modal" @click="onModal('signup')">Inscription</button>
             </div>
            <div class="d-flex my-1" v-else>
                <router-link :to="{name: 'ross'}" class="btn btn-warning mr-3">Mon compte</router-link>
                <button class="btn btn-outline-light" type="button" @click="$store.dispatch('logout')">Se déconnecter</button>
             </div>
          </div>
          </div>
      </nav>
    </header>
    
    <main><router-view/></main>

    <footer class="footer">
      <div class="py-1" style="background-color: #111">
        <div class="d-flex justify-content-between container flex-wrap">
          <div class="my-auto py-1">
            <img src="../assets/img/logo2.png" height="80" class="d-inline-block align-top" alt="">
          </div>
          <div class="my-auto py-1">
            <div class="mt-2 text-center">
                <a href="#" class="btn btn-outline-primary mx-1"><i class="fab fa-facebook-f"></i></a>
                <a href="#" class="btn btn-outline-danger mx-1"><i class="fab component_fa_size fa-google"></i></a>
            </div>
          </div>
          <div class="my-auto py-1">
            <h5 class="text-white gothicb border-bottom">NOUS CONTACTEZ:</h5>
            <p class="text-secondary m-0">Email: contact@ross.com</p>
            <p class="text-secondary m-0">Tel: +229 67 56 45 34</p>
          </div>
        </div>
      </div>
      <div class="py-2" style="background-color: #000">
        <div class="d-flex justify-content-center container flex-wrap">
          <p class="text-secondary m-0">© 2019 Ross. Tous Les Droits Reservés .</p>
        </div>
      </div>
    </footer>
    
    <login-form :status="loading" v-model="payload" @submit="onLogging" @toggle="onModal"/>
    <register-form v-model="payload" @submit="onRegister" @toggle="onModal"/>
  </div>
</template>

<script>
/* eslint-disable */
let loginForm = {
  props: {
    value: Object,
    status: Boolean
  },
  data() {
    return {modal: 'signin'}
  },
  methods: {
    onInput(e) {
      if(e.isValid) this.value.username = e.country.dialCode + e.number
    },
  },
  template: `
  <modal v-model="modal" @close="$emit('toggle', modal)">
    <h5 slot="header">Connectez - vous</h5>
    <form @submit.prevent="$emit('submit', value)">
      <div class="form-group">
        <div role="alert" class="alert alert-danger" v-if="$store.getters.statusOn === 'failure'">Erreur, vérifier vos informations saisies</div>
        <div role="alert" class="alert alert-success" v-if="$store.getters.statusOn === 'success'">Bravo! vous êtes connecté</div>
      </div>
      <div class="form-group">
        <vue-tel-input @onInput="onInput" :disabledFormatting="true" :preferredCountries="['bj']" focus/>
      </div>
      <div class="form-group">
        <input type="password" v-model.trim="value.password" class="form-control" placeholder="Mot de passe" autocomplete>
      </div>
      <div class="form-check form-check-inline">
        <input type="checkbox" v-model="value.remember" class="form-check-input">
        <label class="form-check-label" for="rmr">Se souvenir de moi</label>
      </div>
      <div class="form-group">
        <button type="submit" :class="[{ 'disabled': status }, 'btn btn-outline-dark btn-block btn-lg']">
          <span class="spinner-border" role="status" aria-hidden="true" v-show="status"></span>
          Connexion
        </button>
      </div>
      <ul class="nav justify-content-center mb-3">
        <li class="nav-item">
          <router-link class="nav-link" :to="{name: 'home'}" data-dismiss="modal" data-toggle="modal" data-target="#passwordforget">Mot de passe oublie</router-link>
        </li>
      </ul>
    </form>
  </modal>
  `
};

let registerForm = {
  props: {
    value: Object
  },
  data() {
    return {modal: 'signup'}
  },
  computed: {
      isValid () {
          return !(this.value.email && this.value.passconf && (this.value.passconf.length > 7 && this.value.owner.password === this.value.passconf) && this.value.agree)
      },
  },
  methods: {
      onInput(e) {
        if(e.isValid) this.value.owner.phone = e.country.dialCode + e.number ///@param {string} number @param {Boolean} isValid @param {string} country // Ex: inputted: (AU) 0432 432 432 => number = '+61432421546'
      },
  },
  template: `
  <modal v-model="modal" @close="$emit('toggle', modal)">
    <h5 slot="header">Inscrivez - vous</h5>
    <form @submit.prevent="$emit('submit')">
      <div class="form-group">
        <div role="alert" class="alert alert-danger" v-if="$store.getters.statusOn=='failure'"">Erreur, vérifier vos informations saisies</div>
        <div role="alert" class="alert alert-success" v-if="$store.getters.statusOn=='success'">Bravo! compte créé avec succès, consulter votre mail pour valider</div>
      </div>
      <div class="form-group">
        <vue-tel-input @onInput="onInput" :disabledFormatting="true" :preferredCountries="['bj']"></vue-tel-input>
      </div>
      <div class="form-group">
        <input type="email" v-model.trim="value.email" class="form-control"  placeholder="Email" required>
      </div>
      <div class="form-group">
        <div class="form-row">
          <div class="col-md-6"><input type="password" v-model.trim="value.owner.password" class="form-control" placeholder="Mot de passe" required autocomplete></div>
          <div class="col-md-6"><input type="password" v-model.trim="value.passconf" class="form-control" placeholder="Confirmation mot de passe" required autocomplete></div>
          <small class="form-text text-muted">Le mot de passe doit être de 8 caractères alphanumériques minimum !</small>
        </div>
      </div>
      <div class="form-group">
        <div class="form-check">
          <label class="form-check-label">
            <input type="checkbox" class="form-check-input" v-model="value.agree">
            J'accepte vos <a href="#">termes et conditions</a> !
          </label>
        </div>
      </div>
      <div class="form-group d-flex justify-content-between">
        <button type="submit" :class="[{ 'disabled': isValid }, 'btn btn-dark btn-block btn-lg']">
          <span class="spinner-border" role="status" aria-hidden="true" v-show="isValid"></span>
          Inscription
        </button>
      </div>
    </form>
  </modal>
  `
};

export default {
    name: 'layout',
    data() {
      return { loading: false, payload: {type: 'Standard', owner: {}}, error: false }
    },
    methods: {
      onLogging() { 
        this.loading = true; 
        this.$store.dispatch("login", this.payload)
        .then(() => {this.onModal('signin'); this.$router.push({name: 'ross'})})
        .catch(() => this.error = 'Erreur de connexion.')
        .finally(() => this.loading = false);
      },
      onRegister() {    
        this.loading = true;
        this.$store.dispatch("register", this.payload)
        .then(() => this.payload = {type: 'Standard', owner: {}}) //this.onModal('signin');
        .catch(() => this.error = 'Erreur, vérifier vos informations saisies')
        .finally(() => this.loading = false);
      },
      onModal(value) {$(`#${value}`).modal('toggle')}
    },
    filters: {
      capitalize(value) {
        if (!value) return '';
        value = value.toString();
        return value.charAt(0).toUpperCase() + value.slice(1);
      },
      moment(date) {
        //import moment from 'moment'return moment(date).format("MMMM Do, YYYY");
      }
    },
    mounted() {
      var nav = $('#navbar');
      if (nav.length) {
        var contentNav = nav.offset().top;
        $(window).scroll(function() {
          if ($(this).scrollTop() > contentNav) nav.addClass("fixed-top");
          else nav.removeClass("fixed-top");
        });
      } 
    },
    components: {loginForm, registerForm}
}
</script>

<style lang="scss">
  @import '~vue-tel-input/dist/vue-tel-input.css';
</style>